/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import { ParametresGeneraux } from '@/types';

const validationTabRecensement = (parametres: Partial<ParametresGeneraux>) => {
  const prepose = parametres?.prepose || {};
  
  return _.pickBy({
    nomPrepose: _.isEmpty(prepose['nom']) ? 'Le nom du responsable est obligatoire' : '',
    prenomPrepose: _.isEmpty(prepose['prenom']) ? 'Le prénom du responsable est obligatoire' : '',
    telephonePrepose: _.isEmpty(prepose['telephone']) ? 'Le téléphone du responsable est obligatoire' : '',
    emailPrepose: _.isEmpty(prepose['email']) ? 'Le courriel du responsable est obligatoire' : '',
  }, v => !_.isNil(v) && !_.isEmpty(v));
};

export default validationTabRecensement;